export default "__VITE_ASSET__CbG6uV4Z__"